module.exports = __webpack_public_path__ + "assets/img/btn_Record.a123d63d.png";